import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import {
  BANK_ACCOUNT_PATH,
  NEW_BANK_ACCOUNT_PATH,
} from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { BANK_ACCOUNT_COLUMNS } from '../../../../config/columns';
import { clearBankAccounts, getBankAccounts } from '../../../../actions';

export const Banks = ({
  breadcrumbs,
  bankAccounts,
  loading,
  dispatchGetBankAccounts,
  dispatchClearBankAccounts,
}) => {
  useLayoutEffect(() => () => dispatchClearBankAccounts(), []);

  const data = bankAccounts.get('content') || [];
  const pages = bankAccounts.get('totalPages') || null;
  const defaultPageSize = bankAccounts.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Cuentas Bancarias"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_BANK_ACCOUNT_PATH}
      tableStructure={{
        columns: BANK_ACCOUNT_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetBankAccounts,
        modelPath: BANK_ACCOUNT_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetBankAccounts: getBankAccounts,
  dispatchClearBankAccounts: clearBankAccounts,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Cuentas Bancarias',
      href: BANK_ACCOUNT_PATH,
    },
  ],
  bankAccounts: AccountingUnit.BankAccount.getIn(['all', 'content']),
  loading: AccountingUnit.BankAccount.getIn(['all', 'loading']),
});

Banks.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  bankAccounts: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetBankAccounts: PropTypes.func.isRequired,
  dispatchClearBankAccounts: PropTypes.func.isRequired,
};

Banks.defaultProps = {
  bankAccounts: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Banks);
